import { isLocal } from "./helpers";

const Socket = new class {
    endpoint = 'wss://getsoapy.com/ws/';
    // endpoint = 'wss://kqljivi45m.execute-api.eu-west-2.amazonaws.com/production';
    socket = null;
    callbacks = {
        open: [],
        message: [],
        close: [],
        error: [],
    };
    queue = [];

    connect() {
        if (isLocal()) {
            // return
        }

        if (this.socket && [WebSocket.CONNECTING, WebSocket.OPEN].includes(this.socket.readyState)) {
            return;
        }

        this.socket = new WebSocket(this.endpoint);

        this.socket.addEventListener('open', () => {
            // console.log('Socket opened');
            this.triggerCallbacks('open');

            this.flushQueue();
        });

        this.socket.addEventListener('close', () => {
            // console.log('Socket closed');
            this.triggerCallbacks('close');
        });

        this.socket.addEventListener('error', () => {
            // console.log('Socket error');
            this.triggerCallbacks('error');
        });

        this.socket.addEventListener('message', (message) => {
            const data = JSON.parse(message.data)
            // console.log('Event: ', data);
            this.triggerCallbacks('message', data);
        });
    }

    async disconnect() {
        console.log('Disconnecting socket');

        if (!this.socket) {
            return;
        }

        await this.socket.close();
        this.socket = null;
    }

    async send(payload) {

        const isLocal = window.location.hostname === 'localhost' || window.location.port >= '3000';
        payload.environment = isLocal ? 'local' : 'production';

        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            // console.log('Sending payload', payload);
            await this.socket.send(JSON.stringify(payload));
        } else {
            // console.log('Queueing payload', payload);
            this.queue.push(payload);
        }
    }

    onOpen(callback) {
        return this.addCallback('open', callback);
    }

    onClose(callback) {
        return this.addCallback('close', callback);
    }

    onError(callback) {
        return this.addCallback('error', callback);
    }

    onMessage(callback) {
        return this.addCallback('message', callback);
    }

    triggerCallbacks(event, ...args) {
        this.callbacks[event].forEach((callback) => {
            callback(...args);
        });
    }

    addCallback(event, callback) {
        // Remove it first, prevent duplicates
        this.removeCallback(event, callback);
        this.callbacks[event].push(callback);
        return () => this.removeCallback(event, callback);
    }

    removeCallback(event, callback) {
        const index = this.callbacks[event].indexOf(callback);
        if (index !== -1) {
            this.callbacks[event].splice(index, 1);
        }
    }

    flushQueue() {
        this.queue.forEach((payload) => {
            this.send(payload);
        });
        this.queue = [];
    }
}()

export default Socket;
